<template>
  <modal
    title="Ajouter une intervention"
    @close="cancel()">
    <div class="ronde-ajout">
      <div v-if="ajoutInterventionModal.message !== null" style="margin-top: 2%"
           v-bind:class="'callout callout-'+ajoutInterventionModal.message.type">
        <p>{{ ajoutInterventionModal.message.text }}</p>
      </div>
      <div v-if="mode==='search'">
        <div class="sticky-header">
          <div class="search-form">
            <div class="input-group">
              <span class="input-group-addon"><i class="fa fa-search" aria-hidden="true"></i></span>
              <input type="search" v-on:keyup="searchKeyup()" v-model="q" class="form-control"
                     placeholder="Chercher une adresse">
              <div class="searching-indicator" v-if="ajoutInterventionModal.searching || timeoutSearching">
                <img src="/static/img/loading.svg"/>
              </div>
            </div>
          </div>
        </div>

        <div class="search-results">
          <ul>
            <li class="search-results-item" v-for="r in ajoutInterventionModal.searchResults">
              {{ r.numero }} {{ r.voie }} {{ r.codePostal }} {{ r.ville }}
              <div class="actions" v-on:click="selectAdresse(r)">
                <!--<img src="../../../static/img/arrow-right.svg">-->
                <img src="/static/img/arrow-right.svg">
              </div>
            </li>
          </ul>
          <div v-if="ajoutInterventionModal.searchResults.length == 0">Aucune adresse trouvée.</div>
        </div>
      </div>
      <div v-if="mode==='ordre'">
        <div class="search-results-item">
          {{ selectedAdresse.numero }} {{ selectedAdresse.voie }} {{ selectedAdresse.codePostal }}
          {{ selectedAdresse.ville }}
        </div>
        <div class="explanation"><strong>Veuillez choisir les positions de sortie et/ou de rentrée</strong>
          dans la liste des interventions<br/>(vous pouvez changer l'ordre plus tard en effectuant un drag-and-drop sur
          la liste des interventions)
        </div>
        <div class="sortie_rentree_container">
          <div class="sortie_rentree_hours sortie">
            <div class="icon sortie">
              <img src="/static/img/sortie.svg"/>
            </div>
            <div class="details">
              <span class="kind"><input type="checkbox" v-model="sortieSelected"/> Sortie</span>
              <div class="hours">
                Position: <input type="number" v-model="sortieIndex" min="1"/>
              </div>
            </div>
          </div>
          <div class="sortie_rentree_hours">
            <div class="icon rentree">
              <img src="/static/img/rentree.svg"/>
            </div>
            <div class="details">
              <span class="kind"><input type="checkbox" v-model="rentreeSelected"/> Rentrée</span>
              <div class="hours">
                Position: <input type="number" v-model="rentreeIndex" min="1"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="buttons" v-if="mode === 'ordre' && !ajoutInterventionModal.canOnlyExitModal">
        <div class="btn btn-default" v-on:click="setSearch()">Annuler</div>
        <div class="btn btn-primary" v-on:click="confirmAjoutIntervention()">Ajouter l'intervention</div>
      </div>
      <div class="loading-overlay" v-if="ajoutInterventionModal.loading">
        Chargement ...
      </div>
    </div>

  </modal>
</template>

<script>
import _ from 'lodash'
import Modal from '../../modals/ModalBasic'

let lastTimeout
const KEYUP_TIMEOUT = 200

export default {
  data () {
    return {
      q: '',
      mode: 'search',
      timeoutSearching: false,
      selectedAdresse: null,
      sortieSelected: true,
      rentreeSelected: true,
      sortieIndex: 1,
      rentreeIndex: 2,
    }
  },
  components: {
    Modal,
  },
  computed: {
    ajoutInterventionModal: function () {
      return this.$store.state.rondes.ajoutInterventionModal
    },
  },
  props: [
    'hideDispatchAction',
    'ronde',
  ],
  methods: {
    cancel: function () {
      this.$store.dispatch(this.hideDispatchAction)
    },
    searchKeyup: function () {
      if (lastTimeout) {
        clearTimeout(lastTimeout)
      }
      this.timeoutSearching = true
      lastTimeout = setTimeout(this.doSearch, KEYUP_TIMEOUT)
    },
    doSearch: function () {
      this.timeoutSearching = false
      this.$store.dispatch('searchAdressesV2', this.q)
    },
    selectAdresse: function (adresse) {
      this.selectedAdresse = adresse
      this.mode = 'ordre'
    },
    setSearch: function () {
      this.mode = 'search'
    },
    confirmAjoutIntervention: function () {
      var sortieIndex = parseInt(this.sortieIndex, 10)
      var rentreeIndex = parseInt(this.rentreeIndex, 10)

      if (sortieIndex < 1) {
        sortieIndex = 1
      }
      if (rentreeIndex < 1) {
        rentreeIndex = 1
      }

      if (sortieIndex === rentreeIndex) {
        rentreeIndex = rentreeIndex + 1
      }
      this.$store.dispatch('addInterventionV2', {
        ronde: _.cloneDeep(this.ronde.data),
        adresse: this.selectedAdresse,
        sortieSelected: this.sortieSelected,
        rentreeSelected: this.rentreeSelected,
        sortieIndex: sortieIndex,
        rentreeIndex: rentreeIndex,
      })
    },
  },
}
</script>

<style lang="scss">
@import "../../../scss/variables";

.ronde-ajout {
  margin-top: -30px;

  div.sticky-header {
    position: sticky;
    top: -24px;
    background-color: white; // Adjust the background color as needed
    z-index: 100; // Set a higher z-index to ensure it appears above other elements
    padding: 1rem; // Add padding for spacing
  }

  .input-group {
    .searching-indicator {
      position: absolute;
      right: 0;
      bottom: 0;
      top: 0;
      width: 33px;
      z-index: 20;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .search-results {
    margin-top: 2rem;

    ul {
      list-style: none;
      margin: 0;
      padding: 0;
    }
  }

  .search-results-item {
    background-color: $suez-grey;
    position: relative;
    width: 100%;
    padding: 1em;
    margin-bottom: .5rem;
    padding: 1rem;
    min-width: 600px;
    margin-top: 2%;

    .actions {
      background-color: $suez-green;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      margin: 0;
      display: flex;
      align-items: center;
      padding: 0 1rem;
      cursor: pointer;
    }
  }

  .sortie_rentree_hours {
    float: left;
    width: 50%;
    display: inline-block;
  }

  .explanation {
    padding: 5rem;
    text-align: center;
  }

  .buttons {
    margin-top: 3rem;
    text-align: right;
    padding: 15px;
  }

  .sortie_rentree_container:after {
    content: ""; /* Important, sinon l'élément n'est pas généré. */
    display: table;
    clear: both;
  }
}

</style>



// WEBPACK FOOTER //
// RondeInterventionAjoutModal.vue?09563050